import { DefineComponent } from 'vue';

export type PagesPath = [
    Record<string, () => Promise<DefineComponent>>,
    (name: string) => string,
];

const pagesPaths: PagesPath[] = [
    [
        import.meta.glob<DefineComponent>(
            '/vendor/kibokosrl/kiboko-backoffice-core/resources/js/Pages/**/*.vue',
        ),
        (name) =>
            `/vendor/kibokosrl/kiboko-backoffice-core/resources/js/Pages/${name}.vue`,
    ],
];

export default pagesPaths;
